export default "__VITE_ASSET__Bli9rZgD__"